<template>
    <link-datepicker range :placeholder="$t('LinkFilter.filterTimeFrame')+'...'" :prefixIcon="!!searchIcon?'link-icon-search':null" @change="confirm" ref="picker" :start="dynamicFilter.value.start" :end="dynamicFilter.value.end"/>
</template>

<script>
    import {DynamicFilterMixin} from "../link-dynamic-filter";

    export default {
        name: "link-dynamic-filter-date",
        mixins: [DynamicFilterMixin],
        methods: {
            getValue() {
                const {p_start: start, p_end: end} = this.$refs.picker
                this.dynamicFilter.value = {start, end,}
            },
        }
    }
</script>

<style lang="scss">

</style>